<template>
  <v-dialog
    v-if="hasRestampAccess"
    v-model="dialog"
    fullscreen
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <ButtonDefault
        :button-name="$t('shooting.buttons.stamped')"
        :disabled="shooting.length === 0"
        :outlined="true"
        @click="getStamps"
        v-on="on"
      />
    </template>
    <v-card class="custom-card" tile>
      <v-toolbar dark color="primary">
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <div v-if="!loading" class="restamp-block">
        <div class="image-block">
          <div class="inner-img" :style="{ 'background-image': imagesToDisplay }">
            <img v-if="selectedStamp" class="stamp" :src="selectedStamp.url" alt="" />
          </div>
          <v-btn @click="prevImages" class="image-block_btn image-block_btn__left" small fab
            ><v-icon>keyboard_arrow_left</v-icon></v-btn
          >
          <v-btn
            @click="nextImages"
            :disabled="shootingImageWithoutImageLabel(images).length === index - 1"
            class="image-block_btn image-block_btn__right"
            small
            fab
            ><v-icon>keyboard_arrow_right</v-icon></v-btn
          >
        </div>

        <div class="settings-block">
          <div class="settings-block-inner">
            <div class="center-flex">
              <p class="title-stamp">{{ $t('restamp.label') }}</p>
            </div>
            <v-select
              v-model="selectedStamp"
              return-object
              item-value="id"
              item-text="name"
              :items="stampsWithFormatRestriction"
            ></v-select>
            <v-btn :loading="loadingSend" :disabled="!selectedStamp" color="primary" outlined @click="sendStamp">{{
              $t('restamp.valid')
            }}</v-btn>
          </div>
        </div>
      </div>

      <v-dialog v-model="dialog2" persistent max-width="500px">
        <v-card justify="center">
          <v-card-title class="justify-center">{{ $t('restamp.validateMessage') }}</v-card-title>
          <div class="pa-5 text-center">
            <v-icon x-large color="primary">check_circle_outline</v-icon>
          </div>
          <v-card-text class="pa-3 text-center">
            {{ $t('common.restampShootingMessage') }}
          </v-card-text>
          <div class="pa-3 text-center">
            <v-btn color="primary" text @click="closeAll">OK</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { manageAccessMixin } from '@/mixins/manageAccessMixin.js'
import ButtonDefault from '../common/atoms/ButtonDefault.vue'
export default {
  components: {
    ButtonDefault
  },
  name: 'Restamp',
  mixins: [manageAccessMixin],
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
      loading: false,
      loadingSend: false,
      selectedStamp: null,
      index: 0
    }
  },
  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      shooting: (state) => state.shooting,
      stamps: (state) => state.stamps,
      userOptions: (state) => state.userOptions
    }),
    hasRestampAccess() {
      const options = this.userOptions
      const optionName = 'useRestampShootingOnStampotheque'

      return this.hasOptionAccess(options, optionName)
    },
    stampsWithFormatRestriction() {
      let newStamps = []

      const shootingImage = this.shooting[0]

      if (!shootingImage) return newStamps

      const shootingFormat = shootingImage.format
      const nbStamps = this.stamps.length

      for (let i = 0; i < nbStamps; i++) {
        const stamp = this.stamps[i]
        if (shootingFormat === stamp.format) {
          newStamps.push(stamp)
        }
      }

      return newStamps
    },
    imagesToDisplay() {
      const url = this.images.length > 0 && this.images[this.index].url
      return `url('${url}')`
    }
  },
  created() {
    this.eventKey = this.eventKeyCode.bind(this)
  },
  methods: {
    shootingImageWithoutImageLabel(shooting) {
      return shooting.filter((s) => !s.isLabelImage)
    },
    prevImages() {
      if (this.index > 0) this.index = this.index - 1
    },
    nextImages() {
      const shooting = this.shootingImageWithoutImageLabel(this.images)

      if (this.index < shooting.length - 1) this.index = this.index + 1
    },
    async getStamps() {
      this.loading = true
      const res = await this.$store.dispatch('getStampsFromStampotheque', this.userId)
      if (res) {
        this.loading = false
        window.addEventListener('keydown', this.eventKey)
      }
    },
    eventKeyCode(ev) {
      if (ev.keyCode === 37 && this.index > 0) this.index = this.index - 1
      if (ev.keyCode === 39 && this.index < this.images.length - 1) this.index = this.index + 1
    },
    async sendStamp() {
      const shootingId = this.$route.params.shootingId
      const ownerId = this.$route.params.ownerId
      const productId = this.$route.params.productId
      const idExist = this.selectedStamp && this.selectedStamp.id
      const imagesExist = this.images.length > 0

      if (idExist && imagesExist) {
        // ownerId, productId, shootingId, data
        const payload = {
          data: { stampId: this.selectedStamp.id },
          shootingId,
          ownerId,
          productId
        }

        this.loadingSend = true

        const res = await this.$store.dispatch('sendStampShooting', payload)
        if (res) {
          this.loadingSend = false
          this.dialog2 = true
        } else {
          this.loadingSend = false
        }
      }
    },
    closeModal() {
      this.dialog = false
      this.dialog2 = false
      this.selectedStamp = null
      this.index = 0
      window.removeEventListener('keydown', this.eventKey)
    },
    closeAll() {
      this.closeModal()
      this.$router.push('/shootings')
    }
  }
}
</script>

<style lang="less" scoped>
.custom-card {
  height: 100%;
  overflow: hidden;
}

.restamp-block {
  display: flex;
  height: calc(100% - 54px);
}

.image-block {
  position: relative;
  width: 60%;
  overflow: hidden;
}

.image-block_btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.image-block_btn__left {
  left: 20px;
}

.image-block_btn__right {
  right: 20px;
}

.inner-img {
  position: relative;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-size: 100% auto;
  filter: drop-shadow(0 1px 5px gray);
}

.title-stamp {
  color: rgba(0, 0, 0, 0.6);
}

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.settings-block {
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
}

.settings-block-inner {
  min-height: 200px;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.stamp {
  position: relative;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
}
</style>
